import axios from "axios";

// ══════════════════════════════════════════════════════
//  CLIENTE ÚNICO DE LA API
//  - La URL sale de REACT_APP_API_URL (ver .env.example). Sin ella, la de local.
//  - El token se lee de sessionStorage en CADA petición (interceptor de petición):
//    así un login, un cambio de contraseña o un cierre de sesión se notan al momento.
//  - 401 → sesión caducada o no válida: se limpia la sesión y se avisa a la app
//    (App.js lo registra con alCaducarSesion) para que vaya al login.
//    El 403 NO cierra la sesión: significa «sesión válida pero sin permiso».
// ══════════════════════════════════════════════════════

export const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/+$/, "");

const CLAVE_TOKEN = "token";

export const getToken = () => {
  try {
    return sessionStorage.getItem(CLAVE_TOKEN);
  } catch {
    return null;
  }
};

export const guardarToken = (token) => {
  try {
    if (token) sessionStorage.setItem(CLAVE_TOKEN, token);
  } catch {
    /* sessionStorage no disponible: la sesión durará lo que la pestaña en memoria */
  }
};

export const limpiarSesion = () => {
  try {
    sessionStorage.removeItem(CLAVE_TOKEN);
    // clave antigua (antes se guardaba el usuario entero): se borra por si queda
    sessionStorage.removeItem("user");
  } catch {
    /* nada que limpiar */
  }
};

// App.js registra aquí qué hacer cuando la API dice 401 (cerrar sesión y mandar al login)
let alCaducar = null;
export const alCaducarSesion = (funcion) => {
  alCaducar = funcion;
};

export const API = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { Accept: "application/json" },
});

API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    // Solo si la petición llevaba token: un 401 de un visitante sin sesión no es «caducada»
    const llevabaToken = Boolean(error?.config?.headers?.Authorization);
    if (error?.response?.status === 401 && llevabaToken && getToken()) {
      limpiarSesion();
      if (alCaducar) alCaducar();
    }
    return Promise.reject(error);
  },
);

export default API;
